module.exports = __webpack_public_path__ + "media/images/products/wedding/img-feature-infection-9c0619e9a918cf62c5661d7a427bb413.png";